import T from 'i18n-react';
import translationsDa from './texts-da.yml';
T.setTexts(translationsDa);
export default T;
